<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">PDP职业性格测试帮助你深入了解自己的性格特质和职业适配性</p>
        <p  class="font1" style="padding-top: 1vh;">相信自己的独特优势</p>
        <p  class="font1" style="padding-top: 1vh;">发挥自己潜能</p>
        <p  class="font1" style="padding-top: 1vh;">你将创造更多的职场辉煌</p>
        <div style="text-align: center;margin-top: 4vh;" v-if="!ReportData.pdp">
            <img  src="@/assets/24July/pdp.png" class="all"/>
        </div>
        <div style="margin-top: 4vh;" v-if="ReportData.pdp">
            <p style="padding-top: 1vh;width: 92%;margin: 0 auto;text-align: center;">你已参与过测评，你的职业性格是<a class="font1">{{ ReportData.pdp }}</a></p>
        </div>
        <div style="text-align: center;margin-top: 4vh;" v-if="ReportData.pdp==='猫头鹰型'">
            <img  src="@/assets/24July/maotouying.png" style="width: 30%;"/>
        </div>
        <div style="text-align: center;margin-top: 4vh;" v-if="ReportData.pdp==='老虎型'">
            <img  src="@/assets/24July/tiger.png" style="width: 30%;"/>
        </div>
        <div style="text-align: center;margin-top: 4vh;" v-if="ReportData.pdp==='孔雀型'">
            <img  src="@/assets/24July/peacock.png" style="width: 30%;"/>
        </div>
        <div style="text-align: center;margin-top: 4vh;" v-if="ReportData.pdp==='考拉型'">
            <img  src="@/assets/24July/koala.png" style="width: 30%;"/>
        </div>
        <div style="text-align: center;margin-top: 4vh;" v-if="ReportData.pdp==='变色龙型'">
            <img  src="@/assets/24July/bianselong.png" style="width: 30%;"/>
        </div>
        <div style="text-align: center;margin-top: 4vh;" v-if="!ReportData.pdp">
            <el-button type="primary" @click="goTest()">点击开始测试</el-button>
        </div>
       
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    components: {},
    data() {
        return {
            
        }
    }, 
    created(){
       
    },
    methods: {
        goTest() {
            // 跳转到PDP测试页面
            window.location.href = 'https://survey.foxconnedu.com/pdp';
        }
    },
}
</script>

<style scoped>
.body {
    background: 
                url("../../assets/25July/logo.png") right  top  no-repeat,
                url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat,
                url("../../assets/25July/bg.jpg")  no-repeat;
    background-size:100% 100%, 55%,cover;
    width: 100%;
    height: 100vh;
}

ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}

li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}

.all{
    width: 50%;
}

.font1 {
    width: 90%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #7126d3;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #176ed2;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
    .body {
        background: 
                    url("../../assets/25July/pcbg.jpg")  no-repeat;
        background-size:cover;
        width: 100%;
        height: 100vh;
    }

    .font1 {
        width: 90%;
        margin: 0 auto;
        text-align: center;
        font-size: 20px;
        color: #7126d3;
        font-weight: bold;
        font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
    }

    .all{
        width: 50%;
    }
}
</style>